import { render } from "./OutgoingItems.vue?vue&type=template&id=af3a2ffe&scoped=true"
import script from "./OutgoingItems.vue?vue&type=script&lang=js"
export * from "./OutgoingItems.vue?vue&type=script&lang=js"

import "./OutgoingItems.vue?vue&type=style&index=0&id=af3a2ffe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3a2ffe"]])

export default __exports__